module.exports = __webpack_public_path__ + "img/facebook.d80b564e.svg";